"use strict";
// Sources:
// regression: https://people.richland.edu/james/lecture/m170/ch11-reg.html
// stdev: http://libweb.surrey.ac.uk/library/skills/Number%20Skills%20Leicester/page_19.htm
// MSE: https://en.wikipedia.org/wiki/Mean_squared_error
// NMSE: http://math.stackexchange.com/questions/488964/the-definition-of-nmse-normalized-mean-square-error
Object.defineProperty(exports, "__esModule", { value: true });
function regressionLine(input) {
    const data = input.map(item => ({
        x: item.x.getTime(),
        y: item.y
    }));
    const meanY = data.reduce((sum, { y }) => sum + y, 0) / data.length;
    // stdev
    const diffs = data.reduce((curr, { y }) => curr + Math.pow(y - meanY, 2), 0);
    const sigmaY = Math.max(Math.pow(diffs / data.length, 0.5), Number.EPSILON); // never 0
    // Calculate a dataset with obvious outliers removed
    const reducedData = data.filter(({ y }) => Math.abs(y - meanY) < 3 * sigmaY);
    const sums = {
        x: 0,
        y: 0,
        xy: 0,
        x2: 0,
        y2: 0
    };
    reducedData.forEach(({ x, y }) => {
        sums.x += x;
        sums.y += y;
        sums.xy += x * y;
        sums.x2 += x * x;
        sums.y2 += y * y;
    });
    const mTop = reducedData.length * sums.xy - sums.x * sums.y;
    const mBottom = reducedData.length * sums.x2 - sums.x * sums.x;
    const m = mTop / mBottom;
    const cTop = sums.y * sums.x2 - sums.x * sums.xy;
    const cBottom = reducedData.length * sums.x2 - sums.x * sums.x;
    const c = cTop / cBottom;
    const regressionFn = x => m * x + c;
    // Calculate normalised mean squared error (NMSE) with outliers removed
    // eslint-disable-next-line arrow-body-style
    const sumLeastSquares = reducedData.reduce((total, { x, y }) => {
        return total + Math.pow(y - regressionFn(x), 2);
    }, 0);
    const y2reduced = reducedData.reduce((sum, { y }) => sum + y * y, 0);
    regressionFn.NMSE = sumLeastSquares / y2reduced;
    return regressionFn;
}
exports.default = regressionLine;
//# sourceMappingURL=regression-line.js.map